/**
 * CwFilePreview — positioned hover-preview popup for a CW result.
 *
 * Sprint CW-G follow-up. Reuses the visual style from the existing
 * .cw-files__preview-popup tree on the full Connected Search page.
 */
import { type FC } from 'react';
import type { CwPreviewState } from './useCwFilePreview';

interface Props {
  state: CwPreviewState | null;
}

const CwFilePreview: FC<Props> = ({ state }) => {
  if (!state) return null;
  return (
    <div
      className="cw-files__preview-popup"
      style={{
        top: Math.min(state.y, window.innerHeight - 350),
        left: Math.min(state.x, window.innerWidth - 360),
      }}
    >
      <div className="cw-files__preview-header">{state.name}</div>
      {state.embedUrl ? (
        <iframe
          src={state.embedUrl}
          title={state.name}
          className="cw-files__preview-iframe"
          sandbox="allow-scripts allow-same-origin allow-popups"
        />
      ) : state.blobUrl ? (
        <img
          src={state.blobUrl}
          alt={state.name}
          className="cw-files__preview-img"
          referrerPolicy="no-referrer"
        />
      ) : state.previewText || state.previewMeta ? (
        /* CW-IS-W2 TKT-3 — text-only preview for in-system hits. */
        <div className="cw-files__preview-text-card">
          {state.previewText && (
            <p className="cw-files__preview-text">{state.previewText}</p>
          )}
          {state.previewMeta && Object.keys(state.previewMeta).length > 0 && (
            <dl className="cw-files__preview-meta">
              {Object.entries(state.previewMeta).map(([k, v]) => (
                <div key={k} className="cw-files__preview-meta-row">
                  <dt>{k}</dt>
                  <dd>{v}</dd>
                </div>
              ))}
            </dl>
          )}
        </div>
      ) : (
        <div className="cw-files__preview-noimage">Loading preview…</div>
      )}
    </div>
  );
};

export default CwFilePreview;
